// extracted by mini-css-extract-plugin
module.exports = {"customerSuccess":"style_customerSuccess__Ok3M_"};